import { Component, Injector, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ItemsListContainerBase } from '@fi-app/components/items-list-container-base';
import { ListData } from '@fi-app/components/items-list/list-data.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { BillingService } from '../../billing.service';
import { BillingCompanyInformationListData } from '../billing-company-information-list-data';
import { BusinessUnitCompanyInformationModel } from '../business-unit-company-information.model';
import { IBillingModuleModel } from '@fi-app/billing/billing-header/billing-header.component';

@Component({
    selector: 'fi-billing-company-information-list',
    template: `<fi-items-list [settings]="ListData"></fi-items-list>`,
    styleUrls: ['./billing-company-information-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-billing-company-information-list' },
    standalone: false,
})
export class BillingCompanyInformationListComponent
    extends ItemsListContainerBase<ListData<BusinessUnitCompanyInformationModel>>
    implements OnInit
{
    @Input() billingModuleModel: IBillingModuleModel;

    constructor(
        private fiLoadingService: LoadingService,
        private billingService: BillingService,
        private injector: Injector,
    ) {
        super();
    }

    ngOnInit(): void {
        super.onInit(() => new BillingCompanyInformationListData(this.injector), {
            noLocalSearch: true,
            showDelete: false,
        });

        setTimeout(() => (this.billingModuleModel.ListData = this.ListData));
    }

    protected LoadItems(): Promise<void> {
        return this.fiLoadingService.trackPromise(
            this.billingService.GetBusinessUnitCompanies().then((items) => {
                this.ListData.appendData(items);
            }),
        );
    }
}
